module.exports = __webpack_public_path__ + "img/@event-banner.935c4b2c.jpg";